import clsx from "clsx";
import { FC } from "react";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { UserRole } from "../../../../app/transports/user";
import { useAuth } from "../../../../app/utils/useAuth";
import { ActivitiesMenu, QuickLinksMenu, UserMenu } from "src/app/components";

const Topbar: FC<any> = (props: { aside: any }) => {
    const { currentUser } = useAuth();
    return (
        <>
            <div className="d-flex w-100 align-items-stretch justify-content-between">
                <UserMenu />
                {currentUser?.role == UserRole.ROLE_ADMIN && <QuickLinksMenu />}
                <ActivitiesMenu />

                {props.aside.minimize && (
                    <div
                        id="kt_aside_toggle"
                        className="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
                        data-kt-toggle="true"
                        data-kt-toggle-state="active"
                        data-kt-toggle-target="body"
                        data-kt-toggle-name="aside-minimize"
                    >
                        <KTSVG
                            path={"/media/icons/duotune/arrows/arr080.svg"}
                            className={"svg-icon-1 rotate-180"}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export { Topbar };
